import { render, staticRenderFns } from "./WorkingHoursHolidays.vue?vue&type=template&id=127768f8&scoped=true&"
import script from "./WorkingHoursHolidays.vue?vue&type=script&lang=js&"
export * from "./WorkingHoursHolidays.vue?vue&type=script&lang=js&"
import style0 from "./WorkingHoursHolidays.vue?vue&type=style&index=0&id=127768f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127768f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
